import styled from 'styled-components';
// @ts-ignore
import { useTranslation } from 'react-i18next';
import logo from '../assets/trademark_logo.svg';
import {
  version, releaseDate, releaseMonth, releaseYear,
} from '../version';

const MONTH_INDEX: Record<string, number> = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

function getSanitizedLocale(language: string): string {
  const tag = language?.replace(/_/g, '-');

  if (tag && Intl.DateTimeFormat.supportedLocalesOf([tag]).length > 0) {
    return tag;
  }

  return 'en';
}

const FooterComponent = styled.div`
  color: ${(props) => props.theme.palette.grey[50]};
  text-align: center;
  padding: 30px 0 50px 0;
  width: 100%;
  
  &>div {
    margin: 20px auto;
    align-items: center;
    width: 30%;
    
    img {
      margin: 0 20px 0 40px;
    }
  }
  
  &>p {
      margin: 0 auto;
      font-size: 0.8em;
      color:white;
      padding: 0 56px 0 56px;
      max-width: 1000px;
      overflow-wrap: break-word;
  }
    &>p>a {
        font-size: 1em;
        color:white;
    }
`;

export default function Footer() {
  const { t, i18n } = useTranslation();

  const monthIndex = MONTH_INDEX[releaseMonth];

  const locale = getSanitizedLocale(i18n.language);
  const formattedDate = monthIndex !== undefined && !/^en\b/i.test(locale)
    ? new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(Number(releaseYear), monthIndex, Number(releaseDate))))
    : t('Footer.Date', {
      releaseDate,
      releaseMonth: t(releaseMonth),
      releaseYear,
    });

  return (
    <FooterComponent>
      <img src={logo} alt="CRIO" width="112px" />
      <br />
      <p>
        {t('Footer.Powered by CRIO')}
        <span>{t('Footer.Version', { version })}</span>
        &nbsp;
        &copy;
        &nbsp;
        {formattedDate}
            &nbsp;
        {t('Footer.All Rights Reserved')}
        <br />
        <br />
        {t('Footer.Footer Text')}
        <br />
        <a href="https://app.clinicalresearch.io/privacy" target="_blank" rel="noopener noreferrer">
          {t('Footer.Privacy Policy')}
        </a>
      </p>
    </FooterComponent>
  );
}
